module.exports = __webpack_public_path__ + "static/media/spinner.ed5bf546.gif";